var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "linkedin_footer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedin_footer",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.14388095,9.31241951 L8.14388095,18.2430427 L5.17545827,18.2430427 L5.17545827,9.31241951 L8.14388095,9.31241951 Z M15.4275352,9.10281618 C17.3803959,9.10281618 18.8449146,10.3792836 18.8449146,13.1223826 L18.8449146,13.1223826 L18.8449146,18.2430427 L15.8767455,18.2430427 L15.8767455,13.4654391 C15.8767455,12.2648684 15.4471432,11.4458941 14.3730106,11.4458941 C13.5529376,11.4458941 13.0645957,11.9982157 12.8500058,12.531352 C12.7715736,12.7222769 12.7522191,12.988845 12.7522191,13.2558357 L12.7522191,13.2558357 L12.7522191,18.2430427 L9.78388095,18.2430427 L9.78388095,9.31241951 L12.7523881,9.31241951 L12.7523881,10.6075653 L12.7523881,10.6075653 L12.7763872,10.5754099 C12.9431241,10.3572478 13.9654307,9.10281618 15.4275352,9.10281618 Z M6.67927765,5.00718398 C7.6948396,5.00718398 8.3197618,5.67394234 8.3391163,6.550304 C8.3391163,7.40731117 7.6948396,8.09308593 6.65958509,8.09308593 L6.65958509,8.09308593 L6.6403151,8.09308593 C5.64410765,8.09308593 5,7.40731117 5,6.550304 C5,5.67394234 5.66388475,5.00718398 6.67927765,5.00718398 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLinkedin);
export default __webpack_public_path__ + "static/media/ic_linkedin.5a8923ec.svg";
export { ForwardRef as ReactComponent };